<template>
  <div>
    <div class="pagination-block" v-if="total > 0">
      <div class="left" v-if="selectionShow"
        >选中{{ multipleSelection.length }}条,显示第 {{ (currentPage - 1) * pageSize + 1 }} 条到
        {{
          (currentPage - 1) * pageSize + pageSize > total
            ? total
            : (currentPage - 1) * pageSize + pageSize
        }}
        条记录，共 {{ total }} 条记录</div
      >
      <div v-else></div>
      <el-pagination
        v-if="total > 0"
        class="right"
        ref="page"
        background
        @size-change="handleSizeChange"
        @current-change="handlePagination"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="pageSize"
        :total="total"
        layout="sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'index',
    props: {
      selectionShow: {
        type: Boolean,
        default: true,
      },
      multipleSelection: {
        type: Array,
        default: () => [],
      },
      page: {
        type: Number,
        default: 1,
      },
      limit: {
        type: Number,
        default: 10,
      },
      total: {
        type: Number,
      },
    },
    computed: {
      currentPage: {
        get() {
          return this.page;
        },
        set(val) {
          this.$emit('update:page', val);
        },
      },
      pageSize: {
        get() {
          return this.limit;
        },
        set(val) {
          this.$emit('update:limit', val);
        },
      },
    },
    data() {
      return {};
    },
    methods: {
      handleSizeChange(val) {
        this.$emit('pagination', { page: this.currentPage, limit: val });
      },
      handlePagination(val) {
        this.$emit('pagination', { page: val, limit: this.pageSize });
      },
    },
  };
</script>

<style scoped></style>
